// src/locales/es.ts — Spanish
import type { TranslationKey } from './en'

const es: Record<TranslationKey, string> = {
  // Navigation
  'nav.dashboard': 'Panel',
  'nav.tests': 'Pruebas',
  'nav.sat': 'SAT',
  'nav.psat': 'PSAT',
  'nav.act': 'ACT',
  'nav.practice': 'Practicar',
  'nav.learn': 'Aprender',
  'nav.videos': 'Videos',
  'nav.bookmarks': 'Marcadores',
  'nav.pricing': 'Precios',
  'nav.groups': 'Grupos',
  'nav.signIn': 'Iniciar sesion',
  'nav.signOut': 'Cerrar sesion',

  // Dashboard
  'dashboard.welcomeBack': 'Bienvenido de nuevo',
  'dashboard.scorePrediction': 'Prediccion de puntaje',
  'dashboard.studyPlan': 'Plan de estudio',
  'dashboard.quickDrill': 'Ejercicio rapido',
  'dashboard.inviteFriends': 'Invitar amigos',

  // Common
  'common.start': 'Iniciar',
  'common.resume': 'Continuar',
  'common.retake': 'Repetir',
  'common.submit': 'Enviar',
  'common.next': 'Siguiente',
  'common.previous': 'Anterior',
  'common.cancel': 'Cancelar',
  'common.save': 'Guardar',
  'common.loading': 'Cargando',

  // Results
  'results.score': 'Puntaje',
  'results.correct': 'Correctas',
  'results.incorrect': 'Incorrectas',
  'results.time': 'Tiempo',
  'results.viewResults': 'Ver resultados',
  'results.downloadPdf': 'Descargar PDF',
  'results.share': 'Compartir',

  // Practice
  'practice.byTopic': 'Practicar por tema',
  'practice.checkAnswer': 'Verificar respuesta',
  'practice.explanation': 'Explicacion',

  // Pricing
  'pricing.freePlan': 'Plan Gratuito',
  'pricing.proPlan': 'Plan PRO',
  'pricing.upgrade': 'Mejorar plan',
  'pricing.monthly': 'Mensual',
  'pricing.testsPerMonth': 'pruebas por mes',
  'pricing.unlimited': 'Ilimitado',

  // Language selector
  'language.label': 'Idioma',
}

export default es
